export default "__VITE_ASSET__Bh_TmEZm__"